import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Consult from "./pages/Consult";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { initPixel } from "./lib/pixel";
// Self-hosted fonts. Hanken Grotesk = warm humanist UI/body; Newsreader = editorial display serif.
import "@fontsource/hanken-grotesk/400.css";
import "@fontsource/hanken-grotesk/500.css";
import "@fontsource/hanken-grotesk/600.css";
import "@fontsource/hanken-grotesk/700.css";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/600-italic.css";
import "@fontsource/cormorant-garamond/700.css";
import "./index.css";

// Meta Pixel (F1.4) — no-op si VITE_META_PIXEL_ID no está configurado.
initPixel();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        {/* Vehículo hero — quiz de interiores */}
        <Route path="/quiz" element={<Consult />} />
        {/* Legales (requeridas por Meta + carriers A2P + TCPA) */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
